import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<rect x="4" y="5" width="16" height="14" rx="2" fill="white" />
			<circle cx="12" cy="9" r="3" fill="#008080" />
			<circle cx="12" cy="8" r="1" fill="white" />
			<rect x="11.5" y="9.5" width="1" height="2" rx="0.5" fill="white" />
			<rect x="6" y="14" width="12" height="2" rx="0" fill="#008080" />
			<rect x="6" y="17" width="8" height="1.5" rx="0" fill="#008080" />
		</svg>
	);
	return icon;
}

export default icon;
